/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Access_Token_InvalidInputs */

const en_error_access_token_invalid = /** @type {(inputs: Error_Access_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The token is not valid any more.`)
};

/**
* | output |
* | --- |
* | "The token is not valid any more." |
*
* @param {Error_Access_Token_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_access_token_invalid = /** @type {((inputs?: Error_Access_Token_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Access_Token_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_access_token_invalid(inputs)
});